import * as errors from './modules/errors/index.js';
import * as standard from './modules/standard/index.js';
import english from './modules/translations/english.js';
import french from './modules/translations/french.js';
import map from './modules/translations/map.js';
import tokens from './modules/translations/tokens.js';
export default {
  errors: {
    get: (errorCode, language = 'en', params = [], skipErrorCode = false) => errors.getVerbiage(errorCode, language, params, skipErrorCode),
    sysMsg: (errorCode, params = []) => errors.getSysMsg(errorCode, params),
    responseCode: errorCode => errors.getResponseCode(errorCode)
  },
  standard: {
    get: (code, language = 'en', params = []) => standard.getVerbiage(code, language, params)
  },
  translations: {
    english,
    french,
    tokens,
    map
  }
};